module.exports = __webpack_public_path__ + "static/media/robot-legs-shadow.f067bfeb.svg";